/* Parte superior de la ficha: % de descuento, "Ahorras" y selector de 1/2/3 unidades */
(function () {
  function fmt(cents) {
    if (window.MM && typeof MM.formatMoney === 'function') return MM.formatMoney(cents);
    return '$' + Math.round(cents / 100).toLocaleString('es-CO');
  }
  function init() {
    var section = document.querySelector('[data-product-section]');
    if (!section) return;
    var idInput = section.querySelector('[data-variant-id-input]');
    var json = section.querySelector('[data-product-variants-json]');
    var variants = [];
    if (json) { try { variants = JSON.parse(json.textContent); } catch (e) {} }
    function currentVariant() {
      if (!idInput) return null;
      var id = String(idInput.value);
      for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === id) return variants[i]; }
      return null;
    }

    /* ---- Descuento y ahorro ---- */
    var box = section.querySelector('[data-ptop-save]');
    function updateSave(v) {
      if (!box || !v) return;
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      box.hidden = !onSale;
      if (onSale) {
        var save = v.compare_at_price - v.price;
        var pctEl = box.querySelector('[data-ptop-pct]');
        var amtEl = box.querySelector('[data-ptop-amount]');
        if (pctEl) pctEl.textContent = Math.floor(save * 100 / v.compare_at_price);
        if (amtEl) amtEl.textContent = fmt(save);
      }
    }

    /* ---- Selector de unidades ---- */
    var tiersWrap = section.querySelector('[data-ptiers]');
    var tiers = tiersWrap ? tiersWrap.querySelectorAll('[data-ptier]') : [];
    var qty = section.querySelector('form [data-quantity-value]') || section.querySelector('[data-quantity-value]');
    function selectTier(n) {
      tiers.forEach(function (t) {
        var on = Number(t.dataset.qty) === n;
        t.classList.toggle('is-selected', on);
        var r = t.querySelector('input'); if (r) r.checked = on;
      });
    }
    function updateTierPrices(v) {
      if (!v) return;
      tiers.forEach(function (t) {
        var n = Number(t.dataset.qty), d = Number(t.dataset.disc || 0);
        var full = v.price * n, pay = Math.round(full * (100 - d) / 100);
        var tot = t.querySelector('[data-ptier-total]'), fu = t.querySelector('[data-ptier-full]'), un = t.querySelector('[data-ptier-unit]');
        if (tot) tot.textContent = fmt(pay);
        if (fu) fu.textContent = fmt(full);
        if (un) un.textContent = fmt(Math.round(pay / n));
      });
    }
    if (tiers.length && qty) {
      tiers.forEach(function (t) {
        t.addEventListener('click', function (e) {
          var n = Number(t.dataset.qty);
          selectTier(n);
          if (String(qty.value) !== String(n)) {
            qty.value = n;
            qty.dispatchEvent(new Event('input', { bubbles: true }));
            qty.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
      function syncFromQty() { selectTier(Number(qty.value)); }
      qty.addEventListener('input', syncFromQty);
      qty.addEventListener('change', syncFromQty);
      section.querySelectorAll('[data-quantity-minus],[data-quantity-plus]').forEach(function (b) {
        b.addEventListener('click', function () { setTimeout(syncFromQty, 0); });
      });
    }

    section.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-variant-option]')) {
        setTimeout(function () { var v = currentVariant(); updateSave(v); updateTierPrices(v); }, 30);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
